module.exports = "stepActivation:\n  publish:\n    branches: [master]\n\nbuildpack:\n  host: git.hubteam.com\n  organization: HubSpotProtected\n  repository: blazar-buildpack-asset-bender\n  branch: master\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/code/buildconfig.yaml
// module id = 938
// module chunks = 0